var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.525 9h-3.525v-2c0-1.032.084-1.682 1.563-1.682h1.868v-3.18c-.909-.094-1.823-.14-2.738-.138-2.713 0-4.693 1.657-4.693 4.699v2.301h-3v4l3-.001v9.001h4v-9.003l3.066-.001z",
    fill: "currentColor"
  })));
}
export default SvgFacebookreact;